var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import indexOf from 'lodash/indexOf';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import split from 'lodash/split';
import React from 'react';
import IconContext from './IconContext';
import { getIconSettledProps, useInsertStyles, normalizeAttrs } from '../utils';
var loopRender = function (key, props, supportColor, svgProps, colorList, levelColors) {
    if (levelColors === void 0) { levelColors = []; }
    var isRootNode = props.isRootNode, name = props.name, _a = props.attributes, attributes = _a === void 0 ? {} : _a, children = props.children;
    var compProps = (function () {
        if (isRootNode) {
            return __assign(__assign({ key: key }, normalizeAttrs(attributes)), svgProps);
        }
        if (!attributes.fill || !supportColor) {
            return __assign({ key: key }, normalizeAttrs(attributes));
        }
        var fill = attributes.fill;
        var colorLevel = indexOf(levelColors, fill);
        if (colorLevel < 0) {
            levelColors.push(fill);
            colorLevel = levelColors.length - 1;
        }
        var colorFill = get(colorList, colorLevel, '').replace(' ', '') || fill;
        return __assign(__assign({ key: key }, normalizeAttrs(attributes)), { fill: colorFill });
    })();
    return React.createElement(name, compProps, isEmpty(children) ? undefined : map(children, function (child, index) {
        return loopRender("".concat(key, "-").concat(name, "-").concat(index), child, supportColor, {}, colorList, levelColors);
    }));
};
var IconBase = React.forwardRef(function (props, ref) {
    var _a = props.svgJson, svgJson = _a === void 0 ? {} : _a, color = props.color, restProps = __rest(props, ["svgJson", "color"]);
    var prefixCls = React.useContext(IconContext).prefixCls;
    var _b = svgJson, icon = _b.icon, name = _b.name;
    var _c = getIconSettledProps(__assign(__assign({}, restProps), { name: name, prefixCls: prefixCls })), spanProps = _c.spanProps, svgProps = _c.svgProps;
    var supportColor = name.startsWith('multiTone-') || name.startsWith('filled-');
    var colorList = split(color, ',');
    useInsertStyles();
    return (React.createElement("span", __assign({}, spanProps, { ref: ref }), loopRender("svg-".concat(name), icon, supportColor, svgProps, colorList)));
});
IconBase.displayName = 'IconBase';
export default IconBase;
